module.exports = __webpack_public_path__ + "img/pass.655009c7.png";